import React from 'react';
import classnames from 'classnames';
import { Button } from '../Button';
export const ButtonToggleItem = React.forwardRef(function ({ color, disabled, hidden, icon, iconName, name, onClick, selected, size, text, value, }, ref) {
    let realColor = 'default';
    if (selected)
        realColor = color;
    const ButtonToggleItemClasses = classnames('ButtonToggle__Item', {
        'ButtonToggle__Item--hidden': hidden,
        'ButtonToggle__Item--selected': selected,
        'ButtonToggle__Item--not-selected': !selected,
        'ButtonToggle__Item--disabled': disabled,
    });
    return (React.createElement("div", { className: ButtonToggleItemClasses, ref: ref },
        React.createElement("input", { name: name, type: "radio", defaultChecked: selected, className: "ButtonToggle__radio", tabIndex: -1 }),
        React.createElement(Button, { color: realColor, disabled: disabled, fill: "solid", full: true, icon: icon, iconName: iconName, onClick: onClick.bind(null, value), size: size }, text)));
});
//# sourceMappingURL=ButtonToggleItem.js.map